import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	items: [],
	total: 0,
	page: 0,
	size: 20,
	loading: false,
	error: null,
};

/**
 * 다운로드 이력.
 *
 * <b>읽기 전용이다.</b> 이력을 남기는 것은 파일을 내려주는 발급 서버이고, 지우는 수단은
 * 두지 않는다 — 지울 수 있으면 감사 기록이 아니다.
 */
export const downloadSlice = createSlice({
	name: 'download',
	initialState,
	reducers: {
		fetchDownloadRequest: (state) => {
			state.loading = true;
			state.error = null;
		},
		fetchDownloadSuccess: (state, action) => {
			state.items = action.payload?.items ?? [];
			state.total = action.payload?.total ?? 0;
			state.page = action.payload?.page ?? 0;
			state.size = action.payload?.size ?? initialState.size;
			state.loading = false;
		},
		fetchDownloadFailure: (state, action) => {
			// 목록은 비운다. 실패했는데 이전 페이지가 남아 있으면 이번 조건의 결과로 보인다.
			state.items = [];
			state.total = 0;
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const {
	fetchDownloadRequest,
	fetchDownloadSuccess,
	fetchDownloadFailure,
} = downloadSlice.actions;

export default downloadSlice.reducer;
